<template>
    <div
        class="mt-action display-flex align-items-center justify-content-start"
        @click="handleClick"
        :class="{ disabled: props.disabled, loading: loading }"
    >
        <div class="mt-action-icon mr-sm">
            <font-awesome-icon
                v-if="!loading"
                :icon="iconOptions.iconName"
                class="table-action-icon text-moat-600"
                size="lg"
                :style="{ color: iconOptions.iconColor }"
            />
            <AonSpinner v-else :scale="0.15" />
        </div>
        <div class="mt-action-label mr-sm">
            <p class="text-stone-900">{{ label }}</p>
        </div>
    </div>
</template>

<script setup>
const emit = defineEmits(['clicked'])

const props = defineProps({
    label: {
        type: String,
        required: true,
    },
    iconOptions: {
        type: Object,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
})

const handleClick = () => {
    emit('clicked')
}
</script>

<style lang="scss" scoped>
.mt-action {
    cursor: pointer;
    padding: 0px 20px;
    border-right: 2px solid var(--color-stone-300);
    transition: all 0.2s ease-in-out;

    &:last-of-type {
        border-right: none;
    }

    .table-action-icon {
        transition: all 0.2s ease-in-out;
    }

    &.loading {
        pointer-events: none;
        margin-left: 0;
    }

    &:hover {
        .table-action-icon {
            color: var(--color-moat-900) !important;
        }
    }
}
</style>
